/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
const COOKIE_SUBMITTED_FORM = 'form-submitted';
const COOKIE_FORM_ERRORS = 'form-errors';
const COOKIE_FORM_VALUES = 'form-values';

;(function (Flits) {
  /* To load js in all pages */
  if (Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE) {
    Flits.LoadStyleScript('socialLoginJs', window.flitsObjects.allCssJs.socialLoginJs.url)
  }
  if (Flits.Metafields.IS_WISHLIST_PAID && Flits.Metafields.IS_WISHLIST_ENABLE) {
    Flits.LoadStyleScript('wishlistJs', window.flitsObjects.allCssJs.wishlistJs.url)
  }
  Flits(document).on('setAjaxProductDone', function (event) {
    if (Flits('#shopify-section-section-ajax-product .flits-wls-button').length) {
      let productHandle = event.detail.handle
      let productTitle = event.detail.title
      let productId = event.detail.id
      let productImage = event.detail.images.length ? event.detail.images[0] : ''
      Flits('#shopify-section-section-ajax-product .flits-wls-button').attr('data-flits-product-id', productId)
      Flits('#shopify-section-section-ajax-product .flits-wls-button').attr('data-flits-product-handle', productHandle)
      Flits('#shopify-section-section-ajax-product .flits-wls-button').attr('data-flits-product-title', productTitle)
      Flits('#shopify-section-section-ajax-product .flits-wls-button').attr('data-flits-product-image', productImage)
      var is_product_added = Flits.isProductAddedInWishlist(productHandle)
      if (is_product_added) {
        Flits('#shopify-section-section-ajax-product .flits-wls-button').removeClass('flits-wls-inactive')
        Flits('#shopify-section-section-ajax-product .flits-wls-button').addClass('flits-wls-active')
        Flits('#shopify-section-section-ajax-product .flits-wls-button').attr(
          'data-tippy-content',
          Flits.t('Flits.locals.wishlisted_product_page.remove_from_wishlist_button', 'Remove from Wishlist')
        )
        //       wishlist_btn.animateWishlistButton(-1, Flits.t('Flits.locals.wishlisted_product_page.remove_from_wishlist_button', 'Remove from Wishlist'));
      } else {
        Flits('#shopify-section-section-ajax-product .flits-wls-button').removeClass('flits-wls-active')
        Flits('#shopify-section-section-ajax-product .flits-wls-button').addClass('flits-wls-inactive')
        Flits('#shopify-section-section-ajax-product .flits-wls-button').attr(
          'data-tippy-content',
          Flits.t('Flits.locals.wishlisted_product_page.add_to_wishlist_button', 'Add to Wishlist')
        )
        //       wishlist_btn.animateWishlistButton(-1, Flits.t('Flits.locals.wishlisted_product_page.add_to_wishlist_button', 'Add to Wishlist'));
      }
    }
  })
  Flits(document).on('click', '.wishlist-icon', function (e) {
    Flits.navigationFunc('#wishlist')
  })
  /* recalculate mobile menu slider width on account#profile */
  Flits(window).on('load', () => {
    setProfileMenuSliderMobile()
    window.addEventListener('resize', setProfileMenuSliderMobile)
    window.addEventListener('orientationchange', setProfileMenuSliderMobile)
  })

  Flits(window).on('unload', () => {
    window.removeEventListener('resize', setProfileMenuSliderMobile)
    window.removeEventListener('orientationchange', setProfileMenuSliderMobile)
  })

  // Когда загружена страница с адресами в профайле
  Flits(document).on('Flits:deliveryAddress:Loaded', () => {
    // Ждём клик на кнопку добавления нового адреса доставки
    const newAddressButtons = document.querySelectorAll('.flits-new-address-card')
    newAddressButtons.forEach((button) => {
      button.addEventListener('click', handleButtonClick)
    })

    // Выбираем страну Israel в селектах страны и телефона формы
    function handleButtonClick(event) {
      setTimeout(() => {
        const container = event.target.closest('.flits-address-div')
        const selectCountry = container.querySelector('select[name="address[country]"]')
        const selectPhoneCountry = container.querySelector('.flits-country-drpdown select')
        selectCountry.value = 'Israel'
        selectPhoneCountry.value = 'Israel'
        selectCountry.dispatchEvent(new Event('change'))
        selectPhoneCountry.dispatchEvent(new Event('change'))
      }, 100)
    }
  })

  // При загрузке страницы реферальной программы
  Flits(document).on('Flits:referFriendTemplate:Loaded', function (event) {
    Flits(".flits-share-btn[data-flits-share-platform='ms_facebook']").removeClass('flits-hide')
  })
  Flits(document).on('click', '.flits-instagram-button-js', function (event) {
    function forceDownload(blob, filename) {
      var a = document.createElement('a')
      a.download = filename
      a.href = blob
      // For Firefox https://stackoverflow.com/a/32226068
      document.body.appendChild(a)
      a.click()
      a.remove()
    }
    // Current blob size limit is around 500MB for browsers
    function downloadResource(url, filename) {
      if (!filename) filename = url.split('\\').pop().split('/').pop()
      fetch(url, {
        headers: new Headers({
          Origin: location.origin
        }),
        mode: 'cors'
      })
        .then((response) => response.blob())
        .then((blob) => {
          let blobUrl = window.URL.createObjectURL(blob)
          forceDownload(blobUrl, filename)
        })
        .catch((e) => console.error(e))
    }

    awaidownloadResource('https://giant.gfycat.com/RemoteBlandBlackrussianterrier.webm')
    //   Flits.popupWindow("instagram://story-camera")
  })

  Flits(document).on('click', '.flits-share-btn', function (event) {
    const platform = Flits(this).attr('data-flits-share-platform')

    Flits.ajax({
      method: 'GET',
      url: Flits.base_url + '/' + Flits.customer_id + '/refer_friend/get_referral_data',
      data: { customer_hash: Flits.customerHash, token: Flits.token }
    })
    .done(function (resp) {
      const { customer }= resp;

      const SHARE_TITLE = window.decodeHtmlCharCodes(window.Shopify.translations.common.refferral_link_welcome_message)
      const locale = window.langify.locale.root_url === '/' ? window.langify.locale.root_url : `${window.langify.locale.root_url}/`

      const SHARE_MAIL_SUBJECT =   window.decodeHtmlCharCodes(window.Shopify.translations.common.referral_email_subject)

      const referralLink =`https://${location.host}${locale}account/register?flits_refer_code=${
        utf8_to_b64(customer.referral_code)}&flits_inviter_name=${utf8_to_b64(customer.name)}`;

        const urls = {
          ms_facebook: 'https://www.facebook.com/dialog/send?link=' +
          encodeURIComponent(unescape(referralLink)) +
          '&app_id=1126408271296160' +
          '&redirect_uri=https://winest.store/',
          email:`mailto:?subject=${SHARE_MAIL_SUBJECT}&body=${SHARE_TITLE} %0D%0A ${encodeURIComponent(unescape(referralLink))}`,
          facebook: null
        }
        const url = urls[platform]
        url && Flits.popupWindow(url, platform.charAt(0).toUpperCase() + platform.slice(1) + ' Share', window, 700, 700)
    });
  })
  // Change password error banners logic
  Flits(document).on('keyup', '.flits-form-change-password input[name=password]', function () {
    let parentSelector = Flits(this).parents('.flits-form-change-password')
    Flits(parentSelector).find('.flits-change-password-error').removeClass('error-active')
  })
  Flits(document).on('keyup', '.flits-form-change-password input[name=password_confirmation]', function () {
    let parentSelector = Flits(this).parents('.flits-form-change-password')
    Flits(parentSelector).find('.flits-change-password-error').removeClass('error-active')
  })
  Flits('.flits-change-pass-button').on('click', function () {
    let parentSelector = Flits(this).parents('.flits-form-change-password')
    let password = Flits(parentSelector).find('input[name=password]')[0]
    let confirm_password = Flits(parentSelector).find('input[name=password_confirmation]')[0]
    Flits(parentSelector).find('.flits-change-password-error')
    if (password.value.length < 6 || password.value.length > 40 || password.value !== confirm_password.value) {
      Flits(parentSelector).find('.flits-change-password-error').addClass('error-active')
    }
  })

  Flits(document).on('Flits:myProfile:BeforeUpdate', () => {
    let phoneValue = Flits('.flits-profile-form-container').find('.flits-profile-form input[name="phone"]').val()
    let emailValue = Flits('.flits-profile-form-container').find('.flits-profile-form input[name="email"]').val()
    let countryValue = Flits('.flits-profile-form-container')
      .find('.flits-profile-phone-with-country-div .flits-country-code-textbox')
      .val()
    let phoneNumber = countryValue + phoneValue
    try {
      if (!Flits.validateEmail(emailValue)) {
        Flits('.flits-profile-form-container').find('.flits-profile-email-alert ').addClass('error-active')
      }
    } catch({ message }) {
      console.error(`Error validate e-mail value. Error message: ${message}`)
    }
    try {
      if (!Flits.validatePhone(phoneNumber)) {
        Flits('.flits-profile-form-container').find('.flits-profile-phone-alert').addClass('error-active')
      }
    } catch({ message }) {
      console.error(`Error validate phone number. Error message: ${message}`)
    }
  })

  Flits(document).on('Flits:myProfile:Updated', removeSnackbarHidden)
  Flits(document).on('Flits:deliveryAddress:Updated', removeSnackbarHidden);
  Flits(document).on('Flits:deliveryAddress:Added', removeSnackbarHidden);
  Flits(document).on('Flits:changePassword:Updated', removeSnackbarHidden)

  function removeSnackbarHidden() {
    const delay = 100;
    const interval = 100;
    const transitionDuration = 500;

    const timer = (snackbar) => async () => {
      if (!snackbar) {
        const snackbars = Flits('.flits-snackbar-container');

        snackbars.each((_, sb) => {
          requestAnimationFrame(timer(sb));
        });
        return;
      }

      const isVisible = snackbar.style?.opacity && Number(snackbar.style?.opacity) > 0;
      const parent = snackbar.parentElement;

      if (!isVisible) {
        setTimeout(() => {
          snackbar.parentElement?.removeChild(snackbar);
        }, transitionDuration);

        return;
      }

      setTimeout(() => {
        requestAnimationFrame(timer(snackbar));
      }, interval);
    };

    setTimeout(() => {
      requestAnimationFrame(timer())
    }, delay);
  }

  Flits(document).on('keyup', '.flits-profile-form input[name="phone"]', function () {
    if (Flits('.flits-profile-phone-alert').hasClass('error-active')) {
      Flits('.flits-profile-phone-alert').removeClass('error-active')
    }
  })

  Flits(document).on('keyup', ".flits-profile-form [name='email']", function () {
    if (Flits('.flits-profile-email-alert').hasClass('error-active')) {
      Flits('.flits-profile-email-alert').removeClass('error-active')
    }
  })

  Flits(document).on('click', '.referFriend-primary-button', function () {
    Flits('.flits-tingle-modal-close').click()
  })

    Flits(document).on('input', '.flits-input[name="address[phone]"]', function () {
    // Автоочистка нецифровых символов при наборе
    this.value = this.value.replace(/\D/g, '');
  });
  
  Flits(document).on('change', 'select[name="birthyear"]', function () {
    const selectedYear = parseInt(this.value);
    const currentYear = new Date().getFullYear();
    const age = currentYear - selectedYear;

    // Определяем язык страницы
    const lang = document.documentElement.lang || 'en'; // по умолчанию 'en'

    // Сообщения на разных языках
    const messages = {
      en: 'You must be at least 18 years old.',
      de: 'Sie müssen mindestens 18 Jahre alt sein.'
    };

    if (age < 18) {
      alert(messages[lang] || messages.en);
      this.value = 'yyyy'; // сбрасываем выбор
    }
  });
  
  Flits(document).on('paste', '.flits-input[name="address[phone]"]', function (e) {
    e.preventDefault();

    const pasted = (e.originalEvent || e).clipboardData.getData('text');
    const numbers = pasted.replace(/\D/g, '');

    if (numbers.length > 0) {
      const el = this;
      const start = el.selectionStart;
      const end = el.selectionEnd;
      const current = el.value;

      el.value = current.slice(0, start) + numbers + current.slice(end);
      el.setSelectionRange(start + numbers.length, start + numbers.length);
    }
  });

  Flits(document).on('click', '.flits-address-add-save-button', function (event) {
    const phoneEl = Flits('.flits-input[name="address[phone]"]')
    let number = phoneEl.val()
    if (number[0] === '0') {
      phoneEl.val(number.substr(1))
    }
    event.stopPropagation()
  })

  Flits(document).on('click', '.footer-ref-copy-btn',function (event) {

    function decodeHtmlCharCodes(str) {
      return str.replace(/(&#(\d+);)/g, function(match, capture, charCode) {
        return String.fromCharCode(charCode);
      });
    }

    const FORMATTED_SHARE_TITLE = window.decodeHtmlCharCodes(window.Shopify.translations.common.refferral_link_welcome_message);

    async function openSharePanel(data){
      await navigator.share(data);
    }

    Flits
      .ajax({
        method: 'GET',
        url: Flits.base_url + '/' + Flits.customer_id + '/refer_friend/get_referral_data',
        data: { customer_hash: Flits.customerHash, token: Flits.token }
      })
      .done(function (resp) {
        const isMobile = window.innerWidth < 1024;
        const { customer } = resp;
        const locale = window.langify.locale.root_url === '/' ? window.langify.locale.root_url : `${window.langify.locale.root_url}/`;

        const shareableLink =`${FORMATTED_SHARE_TITLE}: https://${location.host}${locale}account/register?flits_refer_code=${utf8_to_b64(customer.referral_code)}&flits_inviter_name=${utf8_to_b64(customer.name)}`;

        if(isMobile){
          try{
            const shareData = {
              text: FORMATTED_SHARE_TITLE,
              url: `https://${location.host}${locale}account/register?flits_refer_code=${utf8_to_b64(customer.referral_code)}&flits_inviter_name=${utf8_to_b64(customer.name)}`,
              title: FORMATTED_SHARE_TITLE
            };

            openSharePanel(shareData);
          }
          catch(err){
            console.error(err);
          }

          return;
        }

        navigator.clipboard.writeText(shareableLink)
        flitsSnackbar.show({
          text: Flits.t('Flits.locals.refer_friend_page.referral_link_copied', 'Link Copied'),
          pos: 'bottom-center',
          showAction: false,
          customClass: 'flits-alert-default',
          duration: 1500,
        });
      })
  });

  // генерируем селектор выбора баллов/кредитов в корзине
  //
  // Opening the cart fires CartRendered three times inside half a second (the
  // drawer re-renders as it settles). Each one used to restart the two-request
  // credit lookup and put the spinner back over the checkout button, which is
  // the flicker people were reporting. One run per burst is enough.
  let creditsRunInFlight = false;
  let creditsSettledAt = 0;
  const CREDITS_FRESH_MS = 2000;

  Flits(document).on('Flits:AjaxCart:CartRendered', () => {
  if (window.WYNCH_LOYALTY_CART) return;
    const sectionCredits = document.querySelector('.cart-credits');
    const sectionEmpty = document.querySelector('.cart-credits-empty');
    const sectionLoader = document.querySelector('.cart-credits-loader');
    const checkoutButton = document.querySelector('#cart-checkout-button [role="button"]');

    if (!sectionCredits || !sectionEmpty || !sectionLoader || !checkoutButton) return;

    // A run is already on its way, or one finished a moment ago and what it
    // rendered still holds.
    if (creditsRunInFlight) return;
    if (Date.now() - creditsSettledAt < CREDITS_FRESH_MS) return;
    creditsRunInFlight = true;

    const showLoader = () => {
      sectionCredits.classList.add('hidden');
      sectionEmpty.classList.add('hidden');
      sectionLoader.classList.remove('hidden');
    };

    // The loader is a CSS-only spinner that the server renders VISIBLE — only JS
    // can take it down. So every exit out of this handler has to end in one of
    // the three states, including the ones where Flits never answers: an
    // unanswered request used to leave it spinning over the checkout button for
    // the rest of the session.
    let settled = false;
    const settle = (render) => {
      if (settled) return;
      settled = true;
      creditsRunInFlight = false;
      creditsSettledAt = Date.now();
      clearTimeout(watchdog);
      try {
        render();
      } catch (err) {
        console.error('cart credits render failed:', err);
        sectionCredits.classList.add('hidden');
        sectionEmpty.classList.add('hidden');
        sectionLoader.classList.add('hidden');
      }
    };

    // Nothing to offer, or we could not find out: drop the block entirely rather
    // than claim the customer has no credits.
    const giveUp = () => settle(() => {
      sectionCredits.classList.add('hidden');
      sectionEmpty.classList.add('hidden');
      sectionLoader.classList.add('hidden');
      delete checkoutButton.dataset.rule;
    });

    // Two chained round trips (cart, then get_credit). Past this, assume silence.
    const watchdog = setTimeout(giveUp, 8000);

    showLoader();

    Flits.getCredits(({ code }) => {
      const generateCredits = () => {
        const templates = [...(sectionCredits?.querySelectorAll('template') || [])];
        const optionSave = templates.filter(template => template.id === 'option-save-credits').pop()?.content.cloneNode(true);
        const optionSpent = templates.filter(template => template.id === 'option-spent-credits').pop()?.content.cloneNode(true);

        if (!optionSave || !optionSpent) return;

        const toMoney = (amount) => Flits.formatMoney(amount, Shopify.moneyFormat);

        const onClick = ({ target }) => {
          checkoutButton.dataset.rule = target.dataset.rule;
        }

        const addSpentOption = ({ selector, credits, totalCredits, ruleId, checked }) => {
          const option = optionSpent.cloneNode(true);
          const radio = option.querySelector('input');
          const span = option.querySelector('span');
          const text = span?.textContent;

          span.textContent = text
            .replace('{{ total_credit }}', toMoney(totalCredits))
            .replace('{{ credit }}', toMoney(credits));

          radio.dataset.rule = ruleId;
          radio.addEventListener('click', onClick);

          if (checked) {
            radio.checked = true;
            onClick({ target: radio });
          }

          selector.appendChild(option);
        };

        const generateCreditsSelector = () => {
          const { rules: spentRules, total_credits: totalCredits } = code || {};
          const selector = document.createElement('ul');

          optionSave.querySelector('input')?.addEventListener('click', onClick);
          spentRules.forEach(({ applicable_credits: credits, rule: { id: ruleId } }, index) => {
            addSpentOption({ selector, credits, totalCredits, ruleId, checked: !index });
          });
          selector.appendChild(optionSave);

          return selector;
        };

        const selector = generateCreditsSelector();

        sectionCredits.innerHTML = '';
        sectionCredits.appendChild(selector);
      };

      // управление отображением блоков нотификации баллов в корзине
      const showCredits = () => {
        const hasSpentCredits = (code?.rules || []).length > 0;

        if (hasSpentCredits) {
          generateCredits();
          sectionCredits.classList.remove('hidden');
          sectionEmpty.classList.add('hidden');
          sectionLoader.classList.add('hidden');
        }
        else {
          sectionEmpty.classList.remove('hidden');
          sectionCredits.classList.add('hidden');
          sectionLoader.classList.add('hidden');
          delete checkoutButton.dataset.rule;
        }
      };

      settle(showCredits);
    }, giveUp);
  });

  // Override Flits forms redirection function
  Flits(document).on('Flits:SocialLogin:Loaded', () => {
    const cartTypes = Flits.getAlpineData('cartBodyTypes');
    const rootUrl = window.langify?.locale.root_url || '';
    const urlPrefix = rootUrl === '/' ? '' : rootUrl;
    const isReferral = document.cookie.indexOf('flits-referral-code') > 0 ||
      Flits('form#create_customer,form#create_customer').find('[name="customer[note][flits_referral_code]"]').length > 0;

    const url = new URL(window.location);
    const getURL = () => `${url.pathname}${url.search}${url.hash}`;
    const getUrlWithParam = (name, value) => {
      url.searchParams.set(name, value);
      return getURL();
    };

    // Visitors who log in / register from the quiz results page
    // (/collections/taste-profile) must land straight on their personalised
    // matches feed — not reopen the cart drawer (?cart=…) and not fall through
    // to the account dashboard. Scope it to that page only; auth from anywhere
    // else keeps the default return-to-current-page behaviour.
    const isResultsPage = /\/collections\/taste-profile(\/|$|\?)/.test(window.location.pathname);
    const resultsRedirect = window.WYNCH_AUTH_ROUTING.getReturnTo('quiz');
    const authReturn = window.WYNCH_AUTH_ROUTING.getReturnTo();

    const params = {
      '#user-login form#customer_login': {
        post: {
          checkout_url: `${urlPrefix}/account#${isReferral ? 'referFriend' : 'profile'}`,
        },
      },
      '#user-register form#create_customer': {
        post: {
          checkout_url: `${urlPrefix}/account/register`,
          return_to: `${urlPrefix}/account/register`,
        },
      },
      '#user-recover form#recover_customer_password': {
        post: {
          checkout_url: `${urlPrefix}/account/login`,
        },
      },
      'body:not(.customers/login) #products-cart form#customer_login': {
        post: {
          checkout_url: authReturn,
        },
      },
      'body.customers/login #products-cart form#customer_login': {
        post: {
          checkout_url: authReturn,
        },
      },
      'body:not(.customers/login) #products-cart form#create_customer': {
        post: {
          return_to: authReturn,
        },
      },
      'body.customers/login #products-cart form#create_customer': {
        post: {
          return_to: authReturn,
        },
      },
      '#products-cart form#recover_customer_password': {
        post: {
          return_to: cartTypes.login ? getUrlWithParam('cart', cartTypes.login) : getURL(),
        },
      },
      'section.reset-account-password form#reset_customer_password': {
        post: {
          return_to: `${urlPrefix}/collections/all`,
        },
      },
    };

    const formsCleanDefault = ['#products-cart form#customer_login', '#products-cart form#create_customer'];

    const initExtraPostParams = () => {
      const { searchParams } = new URL(window.location);

      Object.keys(params).forEach((formSelector) => {
        const form = Flits(formSelector.replace(/\//g, '\\/'));
        const pairs = Object.entries(params[formSelector].post || {});

        if (!form) return;

        pairs.forEach(([name, value]) => {
          const node = form.find(`[name=${name}]`);

          if (searchParams.has(name))
            value = searchParams.get(name);

          if (!node.length)
            form.append(`<input type="hidden" name="${name}" value="${value}">`);
          else
            node.attr('value', value);

          // console.log(
          //   '[flits_custom] Custom addRedirectUrl.initExtraPostParams:',
          //   `[${formSelector} [name=${name}]].value => ${value}`
          // );
        });

        const checkoutUrl = form.find('[name=checkout_url]');
        const returnTo = form.find('[name=return_to]');
        const value = returnTo?.attr('value');

        if (value?.indexOf('checkouts') > -1)
          checkoutUrl.attr('value', value);
      })
    };

    const initExtraGetParams = () => {
      Object.keys(params).forEach((formSelector) => {
        const pairs = Object.entries(params[formSelector].get || {});

        if (!pairs.length) return;

        const form = Flits(formSelector);
        const action = form.attr('action');
        const [actionUrl, actionParams] = action.split('?');
        const extraActionParams = pairs.map(([k, v]) => `${k}=${v}`);
        const newAction = [actionUrl, `${[actionParams, extraActionParams].filter(p => !!p).join('&')}`].join('?');

        form.attr('action', newAction);

        // console.log(
        //   '[flits_custom] Custom addRedirectUrl.initExtraGetParams:',
        //   `[${formSelector}].action => ${newAction}`
        // );
      });
    };

    const removeDefaultInputs = () => {
      const defaultInputs = ['checkout_url', 'return_to', 'return_url'];

      formsCleanDefault.forEach((formSelector) => {
        Flits(formSelector).find(defaultInputs.map((name) => `[name=${name}]`).join(',')).remove();
      })
    };

    Flits.fn.addRedirectUrl__original = Flits.fn.addRedirectUrl;
    Flits.fn.extend({
      addRedirectUrl: function (url) {
        Flits(Flits.SocialLogin.settings.redirectUrlFormSelector.join(",")).addRedirectUrl__original(url);
        return (
          removeDefaultInputs(),
          initExtraPostParams(),
          initExtraGetParams(),
          this
        );
      },
    });
  });

  Flits.extend({
    // Add function of get alpine data to Flits
    getAlpineData: function (name) {
      const dataProxies = document.querySelector('[x-data="app"]')?._x_dataStack || [];
      const error = (msg) => console.error(`[flits_error] Custom getAlpineData:`, msg);

      if (!dataProxies.length) {
        error('cannot find [x-data="app"] node or don`t have any alpine data proxies');
        return null;
      }

      for (let i = 0; i < dataProxies.length; i++) {
        if (name in dataProxies[i]) return dataProxies[i][name];
      }

      error(`cannot find "${name}" property`);
      return null;
    },
  });

  // Mark all required inputs label
  Flits('form label[for]').each((_, label) => {
    const id = label.getAttribute('for');
    const input = label.parentElement.querySelector(`#${id}`);

    if (input?.required) {
      label.textContent += '*'
    }
  })

  // Reset password-repeat validity message
  Flits('form[action*=account] input#password-repeat,form[action*=account] input[name="customer[agreement]"]').on(
    'change',
    ({ target: passwordRepeat }) => {
      passwordRepeat.setCustomValidity('');
    }
  );

  // Store form errors
  Flits('form[action*=account]').on('submit', (event) => {
    event.preventDefault();

    const form = event.target;
    const formId = form.id;
    const sectionId = (() => {
      const getSection = (node) => {
        const parent = node.parentElement;
        if (!parent || parent.nodeName === 'BODY') return node;
        return getSection(parent);
      }
      return getSection(form).id;
    })();
    const button = form.querySelector('[type=submit]');
    const stored = form.querySelectorAll('input[name]');
    const needSpinner = form.classList.contains('with-submit-spinner');

    const redirectTo = (formId === 'customer_login' || formId === 'create_customer')
      ? window.WYNCH_AUTH_ROUTING.getReturnTo()
      : form.querySelector('[name=checkout_url]')?.value || form.querySelector('[name=return_to]')?.value;

    // Check password-repeat value
    const password = form.querySelector('input#password');
    const passwordRepeat = form.querySelector('input#password-repeat');
    if (password?.value && passwordRepeat?.value && password.value !== passwordRepeat.value) {
      passwordRepeat.setCustomValidity(Shopify.forms.validate.passwordRepeatMessage || 'Passwords do not match');
      form.reportValidity();
      return;
    }

    // Check policy and terms accepting
    const agreePolicy = form.querySelector('input[name="customer[agreement]"]');
    if (agreePolicy && !agreePolicy.checked) {
      agreePolicy.setCustomValidity(Shopify.forms.validate.termsAgreeMessage || 'You cannot register if you do not agree')
      form.reportValidity();
      return;
    }

    if (needSpinner && !button?.querySelector('.spinner-submit')) {
      const spinner = document.createElement('span');

      spinner.classList.add('spinner-submit');
      button?.append(spinner);
    }

    if (sectionId && formId)
      Flits.setCookie(COOKIE_SUBMITTED_FORM, `#${sectionId} form#${formId}`);

    if (stored?.length) {
      const values = [...stored].map((node) => `${node.name}::${node.value}`);

      Flits.setCookie(COOKIE_FORM_VALUES, values.join('||'));
    }

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
    })
      .then(async (response) => {
        const data = [];
        const { body, url, ok, status, statusText } = response;
        const reader = body.getReader();
        const decoder = new TextDecoder();

        const result = { url, ok };

        const pump = ({ done, value: chunk }) => {
          if (done) {
            console.log('DONE');

            return {
              ...result,
              data: data.join(''),
            };
          }

          data.push(decoder.decode(chunk));
          console.log(`Read ${chunk.length} characters`);

          return reader.read().then(pump);
        };

        if (!ok) {
          const requestError = window.Shopify?.translations.formErrors.request
            .replace('{{ error_code }}', status)
            .replace('{{ error_text }}', statusText);

          return {
            ...result,
            data: `<div class="errors"><ul><li>${requestError}</li></ul></div>`,
          };
        }

        return reader.read().then(pump);
      })
      .then(({ url, data, ok }) => {
        const [NO_ERRORS, FORM_ERROR, DEFAULT_ERROR] = [0, 1, 2];
        const regexp = /\<div class="errors"\>.+\<\/div\>/gi;
        const errors = data.match(regexp);
        const hasErrors = Boolean(errors?.length);
        const cartForceClose = Boolean(Flits.getAlpineData('cartForceClose'));

        const errorType = (() => {
          if (data.match('Too Many Requests')) return FORM_ERROR;
          if (ok && !hasErrors) return NO_ERRORS;
          return DEFAULT_ERROR;
        })();

        const actions = {
          [NO_ERRORS]: () => {
            const redirectUrl = (redirectTo ? window.location.origin + redirectTo : url)
            const location = new URL(redirectUrl);

            if (cartForceClose && location.searchParams.get('cart') !== '0')
              location.searchParams.set('cartForceClose', '');

            window.location = location;
          },

          [FORM_ERROR]: () => {
            const location = new URL(window.location);

            if (cartForceClose)
              location.searchParams.set('cartForceClose', '');

            location.searchParams.set('hasFormError', '');
            window.location = location;
          },

          [DEFAULT_ERROR]: () => {
            const location = new URL(window.location);

            if (hasErrors)
              Flits.setCookie(COOKIE_FORM_ERRORS, errors[0]);

            if (cartForceClose)
              location.searchParams.set('cartForceClose', '');

            window.location = location;
          },
        };

        actions[errorType]();
      });
  });

  Flits(document).on('DOMContentLoaded', () => {
    showFormErrors();
    showFormPopup();
    clearFormCookies();
  });

  Flits(document).on('click', '.wishlist-register-button', function () {
    const modal = document.querySelector('.flits-tingle-modal');

    modal.classList.remove('flits-tingle-modal-visible');
  });

  Flits(document).on('click', '.wishlist-login-button', function () {
    const modal = document.querySelector('.flits-tingle-modal');

    modal.classList.remove('flits-tingle-modal-visible');
  });

  Flits(document).on('click', '.wishlist-modal-close-button', function () {
    const modal = document.querySelector('.flits-tingle-modal')

    modal.classList.remove('flits-tingle-modal-visible')
  });

  Flits(document).on(
    'click',
    '.boost-pfs-filter-option-item .boost-pfs-filter-button, .boost-pfs-filter-refine-by-wrapper .boost-pfs-filter-button',
    () => {
      setTimeout(() => {
        const url = new URL(window.location);
        const prevPageButton = document.querySelector('.boost-pfs-filter-btn-load-previous-page-wrapper');
        const isButtonHidden = prevPageButton.style.display === 'none';

        url.searchParams.delete('page');

        if (isButtonHidden) {
          window.history.pushState({}, '', url);
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
          });
        } else {
          window.location = url.toString();
        }
      }, 0);
    }
  );

  // Переопределяем модалку флитца при добавлении товара в вишлист на нашу
  Flits(document).on('click', '.flits-wls-button', () => {
    if (Flits.customer_id > 0) return;

    setTimeout(() => {
      const template = document.querySelector('template#add-wishlist-popup')
      const content = template.content.cloneNode(true);

      const showPopup = Flits.getAlpineData('showPopup');
      const popupClasses = Flits.getAlpineData('popupClasses');

      Flits('.flits-tingle-modal-popup-container').removeClass('flits-tingle-modal-visible');

      showPopup(content, { black: false, closeButton: true, customClass: popupClasses.addToWishlist });
    }, 0);
  });

})(Flits)

Flits(window).on('load', function () {
  const inviterName = Flits.getCookie('inviter_name');

  if(!inviterName) return;

  let contentText = Flits.t(
    'Flits.locals.refer_friend_page.popup_message',
    'You were referred by {{ inviter_name }}. Please help us in giving you credit by signing up here.'
  ).replace('{{ inviter_name }}', '<strong>' + inviterName + '</strong>');

  document.querySelector('.flits-formatted-tingle-modal-popup-text').innerHTML = contentText;
  Flits.setCookie('inviter_name', '');
});

function setProfileMenuSliderMobile() {
  const refineSliderWidth = () => {
    const slider = document.querySelector(
      ".flits-account-container .flits-account-section.flits-mobile-view .flits-slider-menu-nav .flits-slider-track"
    );

    if (!slider) {
      requestAnimationFrame(refineSliderWidth);
    } else {
      slider?.style.setProperty("width", "2000px");

      setTimeout(() => {
        Promise.resolve()
          .then(() => {
          })
          .then(() => {
            const items = [...(slider?.children || [])];
            const widths = items.map((item) => item.getBoundingClientRect().width).filter((width) => width > 0);
            const gap = slider
              ? Number(window.getComputedStyle(slider).getPropertyValue("column-gap").replace(/\D/g, ""))
              : 0;
            const width = widths.reduce((acc, width) => (acc + width), 0);
            const widthTotal = Math.ceil(width + gap * (widths.length - 1));

            slider?.style.setProperty("width", `${widthTotal}px`);
          });
      }, 5000);
    }
  };

  requestAnimationFrame(refineSliderWidth);
}

Flits(document).on('click', '.referral-share-button', async function () {
  const referralLink = Flits('input[name="referral link"]').val()
  const description = Flits.t(
    'Flits.locals.refer_friend_page.referral_program_invitation_message',
    'You can earn credit for creating an account with {{ shop_name }}. Use this link and get rewarded : {{ link }}'
  )
    .replace('{{ link }}', referralLink)
    .replace('{{ shop_name }}', Flits.shop_name);

  const shareData = {
    text: description,
    url: referralLink
  };

  await navigator.share(shareData);
});

Flits(document).on('click', '#cart-checkout-button [role="button"]', (event) => {
  if (window.WYNCH_LOYALTY_CART) return;
  const options = [...(document.querySelectorAll('.cart-credits input[name="cart-credits-option"]') || [])];
  const ruleId = (() => (options.filter(({ checked }) => Boolean(checked)).pop()?.dataset.rule || null))();

  const setupCartData = (cart) => {
    const exclude = ["sku", "featured_image", "product_description", "title", "url", "handle", "product_type", "product_title", "discounts", "variant_options", "options_with_values", "variant_title"];

    if (!cart) return {};

    return Object.entries(cart).reduce((acc, [k, v]) => {
      if (k === 'token') return { ...acc, 'cart_token': v };
      if (exclude.includes(k)) return acc;
      return { ...acc, [k]: v }
    }, {});
  };

  const registeredToCheckout = (spentRuleId) => {
    const applyCredit = (cart) => {
      const url = [Flits.base_url, Flits.customer_id, 'credit/apply_credit'].join('/');
      const request = {
        url,
        method: 'post',
        data: {
          customer_hash: Flits.customerHash,
          token: Flits.token,
          data: btoa(unescape(encodeURIComponent(JSON.stringify(setupCartData(cart))))),
          spent_rule_id: spentRuleId,
        },
      };

      Flits.ajax(request)
        .done(({ status, code }) => {
          if (!status)
            Flits.redirectToCheckout({ discount: '' });
          else
            Flits.redirectToCheckout({ discount: code });
        })
        .fail(() => {
          Flits.redirectToCheckout({ discount: '' });
        });
    };

    Flits.getCart().done(applyCredit);
  };

  event.preventDefault();
  event.stopPropagation();

  Flits('.cart-checkout-loader').show();

  if (ruleId === null) {
    const giftMessage = Flits('.cart-gift-message textarea').val();

    toCheckout({
      'attributes[Gift Message]': giftMessage,
    });
  } else {
    registeredToCheckout(ruleId);
  }
});

Flits.extend({
  getCredits: (done, fail) => {
    const setupCartData = (cart) => {
      const exclude = ["sku", "featured_image", "product_description", "title", "url", "handle", "product_type", "product_title", "discounts", "variant_options", "options_with_values", "variant_title"];

      if (!cart) return {};

      return Object.entries(cart).reduce((acc, [k, v]) => {
        if (k === 'token') return { ...acc, 'cart_token': v };
        if (exclude.includes(k)) return acc;
        return { ...acc, [k]: v }
      }, {});
    };

    const applyCredits = (cart) => {
      // An empty cart has nothing to spend credits on. This used to return in
      // silence, leaving every caller waiting on a callback that never came.
      if (!cart || cart.total_price <= 0) {
        if (fail) fail();
        return;
      }

      const url = [Flits.base_url, Flits.customer_id, 'get_credit'].join('/');
      const request = {
        url,
        method: 'post',
        data: {
          customer_hash: Flits.customerHash,
          token: Flits.token,
          cart: btoa(unescape(encodeURIComponent(JSON.stringify(setupCartData(cart))))),
        },
      };

      Flits.ajax(request)
        .done((res) => {
          if (done) return done(res);
        })
        .fail(() => {
          if (fail) return fail();
        });
    };

    Flits.getCart()
      .done(applyCredits)
      .fail(() => {
        if (fail) fail();
      });
  },
});

// Работа с кастомными полями профиля пользователя
Flits.extend({
  getCustomFieldsData: () => {
    const url = [Flits.base_url, Flits.customer_id, 'custom-fields/get'].join('/');
    const { shop_token: token, customerHash: customer_hash } = Flits;
    const request = {
      url,
      method: 'get',
      data: {
        currentPage: 'account',
        token,
        customer_hash,
      },
    };

    return Flits.ajax(request)
      .fail(() => {
        console.error('Bad request of Flits.getCustomFieldsData');
        return null;
      })
      .then(({ customerCustomFieldsValues: fields }) => {
        if (!fields) return null;

        return Object.keys(fields).reduce((acc, key) => {
          if (key.endsWith('_history')) return acc;
          return { ...acc, [key]: fields[key] }
        }, {});
      });
  },
  setCustomFieldsData: (fields = {}) => {
    if (typeof fields !== 'object')
      fields = {};

    const url = [Flits.base_url, Flits.customer_id, 'custom-fields/save'].join('/');
    const { shop_token: token, customerHash: customer_hash } = Flits;

    return Flits.getCustomFieldsData().then((storedFields) => {
      const request = {
        url,
        method: 'post',
        data: {
          ...storedFields,
          ...fields,
          from_page: 'account',
          token,
          customer_hash,
        },
      };

      return Flits.ajax(request)
        .fail(() => {
          console.error('Bad request of Flits.setCustomFieldsData');

          return false;
        })
        .then(({ status }) => status);
    });

  },
});

// Override default Flits function to add locale prefix to checkout path.
// Default redirectToCheckout implementation also searches for form but we do not use it, so that code is omitted.
Flits.extend({
  redirectToCheckout: function (parameters) {
    const giftMessage = Flits('.cart-gift-message textarea').val();

    toCheckout({
      ...parameters,
      'attributes[Gift Message]': giftMessage,
    });
  }
});

function getLocalisedCheckoutPath() {
  return `${window.langify.locale.root_url === '/' ? '' : window.langify.locale.root_url}/checkout`;
}

function toCheckout(params) {
  const form = Flits('#cart-checkout-button form');

  const addParameters = () => {
    Object.entries(params).forEach(([name, value]) => {
      const input = Flits(`<input type="hidden" name="${name}" value="${value}" />`);

      form.append(input);
    });
  };

  const localizePath = () => {
    form.attr('action', getLocalisedCheckoutPath());
  };

  addParameters();
  localizePath();

  console.log('[toCheckout]:', params);
  form.submit();
}

function showFormErrors() {
  const formSelector = Flits.getCookie(COOKIE_SUBMITTED_FORM);
  const errorsNode = document.querySelector(`${formSelector} .errors-present`);
  const errors = Flits.getCookie(COOKIE_FORM_ERRORS);

  if (errors?.length && errorsNode) {
    Flits.setCookie(COOKIE_FORM_ERRORS, errors);
    errorsNode.innerHTML = errors;
    errorsNode.classList.remove('hidden');
  }
};

function showFormPopup() {
  const formSelector = Flits.getCookie(COOKIE_SUBMITTED_FORM);
  const formValues = Flits.getCookie(COOKIE_FORM_VALUES);
  const hasErrors = Flits.getCookie(COOKIE_FORM_ERRORS).length;

  const successTemplate = document.querySelector(`${formSelector} template.success-popup`);

  if (hasErrors || !formSelector || !successTemplate) return;

  const content = document.createElement('div');
  const success = successTemplate.content.cloneNode(true);
  const values = formValues.split('||').reduce((acc, value) => {
    const [k, v] = value.split('::');
    return { ...acc, [k]: v };
  }, {});

  const showPopup = Flits.getAlpineData('showPopup');
  const hidePopup = Flits.getAlpineData('hidePopup');
  const popupClasses = Flits.getAlpineData('popupClasses');

  const insertValues = () => {
    let text = content.innerHTML;

    Object.entries(values).forEach(([k, v]) => {
      const pattern = `{{ ${k} }}`;

      text = text.split(pattern).join(`<span class="popup-text popup-text-${k}">${v}</span>`);
    });
    content.innerHTML = text;
  };

  content.appendChild(success);
  insertValues();
  showPopup(content, { black: true, customClass: popupClasses.cookiePopup });

  setTimeout(hidePopup, 5000);
}

function clearFormCookies() {
  setTimeout(() => {
    Flits.setCookie(COOKIE_SUBMITTED_FORM, '');
    Flits.setCookie(COOKIE_FORM_ERRORS, '');
    Flits.setCookie(COOKIE_FORM_VALUES, '');
  }, 3000);
}

function utf8_to_b64(str) {
  try {
    return window.btoa(unescape(encodeURIComponent(str)));
  }
  catch{
    console.log(`Failed to encode ${str}`);

    return '';
  }
}

function b64_to_utf8(str) {
  try {
    return decodeURIComponent(escape(window.atob(str)));
  } catch {
    console.log(`Failed to decode ${str}`);

    return '';
  }
}

const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
if (isIOS) { document.body.classList.add('ios'); }

Flits(document).on('Flits:Navigation:Loaded', (event) => {
  var setting = event.detail.settings;
  [setting.navs[0], setting.navs[3], setting.navs[6], setting.navs[1]] = [setting.navs[3], setting.navs[0], setting.navs[1], setting.navs[6]];
  [setting.navs[3], setting.navs[14], setting.navs[6], setting.navs[9]] = [setting.navs[14], setting.navs[3], setting.navs[9], setting.navs[6]];
})
Flits(document).on('Flits:AccountPage:Loaded', (event) => {
  var setting = event.detail.settings;
  setting.active_tab = '#order';
});
// Flits(document).on('Flits:navigation:After', (event) => {
//   Flits("a[href='#profile']").parent().removeClass("flits-menu-active");
//   Flits("a[href='#order']").parent().addClass("flits-menu-active");
//   if(window.innerWidth>=767){
//     Flits(".flits-profile-div").removeClass("flits-account-box-active");
//     Flits(".flits-order-div").addClass("flits-account-box-active");
//   }
// });
